import axios from "axios";
import { RequisitionResponse } from "../../../types/model/warehouse/requisition";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/warehouse/requisitions`;

export const getEquipmentRequisitions = async (): Promise<RequisitionResponse[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<RequisitionResponse[]>(BASE_URL, {
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};
